module.exports = __webpack_public_path__ + "static/media/DSC00754-3.a946c460.jpg";